import { useState, useEffect, useMemo, useCallback} from 'react'
import { useDispatch, useSelector} from 'react-redux'
import {
    userGenerateData,
    exportSVG,
} from '../actions/memberActions'
import {
    EXPORT_SVG_CLEAR,
} from '../constants/memberConstant'
import Template from '../components/Template'
import {Button, Alert} from 'react-bootstrap'
import Tree from '../components/Tree'
import CollapseTree from '../components/CollapseTree'
import Loader from '../components/Loader'

const Home = () => {
    const [isExport, setIsExport] = useState(false)
    const [isProfile, setIsProfile] = useState(false)
    const [isPoint, setIsPoint] = useState(false)
    const [isTreeSearchOpen, setIsTreeSearchOpen] = useState(false)
    const [treeSearchText, setTreeSearchText] = useState('')
    const [selectedTreeMember, setSelectedTreeMember] = useState(null)
    const [treeViewMode, setTreeViewMode] = useState(() => localStorage.getItem('treeViewMode') || 'radial')
    const dispatch = useDispatch()
    const {user:{data}} = useSelector(state => state.login)
    const {loading:loading_f, error:error_f, familyData} = useSelector(state => state.familyData)
    const {loading:loading_p, file} = useSelector(state => state.exportSVG)
    const membersById = useMemo(() => {
        const map = {}
        if(familyData) {
            familyData.forEach(member => {
                map[member._id] = member
            })
        }
        return map
    }, [familyData])

    const getTreeMemberName = useCallback(member => {
        const names = [member.firstName]
        let current = member
        let guard = 0
        while(current && current.parentId && membersById[current.parentId] && guard < 6) {
            current = membersById[current.parentId]
            names.push(current.firstName)
            guard += 1
        }
        return names.join(' ')
    }, [membersById])

    const treeSearchResults = useMemo(() => {
        if(!familyData || treeSearchText.trim().length < 1) return []
        const keyword = treeSearchText.trim().toLowerCase()
        return familyData
            .map(member => ({ ...member, displayName: getTreeMemberName(member) }))
            .filter(member => member.displayName.toLowerCase().includes(keyword))
            .slice(0, 8)
    }, [familyData, treeSearchText, getTreeMemberName])

    const exportSVGHandler = async type => {
        if(document.querySelector('svg')){
            const svgString = new XMLSerializer().serializeToString(document.querySelector('svg'))
            dispatch(exportSVG({svg:svgString, type}))
        }
    }

    const treeViewModeHandler = () => {
        setTreeViewMode(prev => {
            const next = prev === 'radial' ? 'collapse' : 'radial'
            localStorage.setItem('treeViewMode', next)
            return next
        })
    }

    useEffect(() => {
        if(file){
            const hiddenElement = document.createElement('a');
                  hiddenElement.href = `http://localhost:5000/uploads/${file}`;
                  hiddenElement.download = file;
                  hiddenElement.target = '_blank';
                  document.body.appendChild(hiddenElement);
                  hiddenElement.click();
                  document.body.removeChild(hiddenElement);
                  dispatch({type:EXPORT_SVG_CLEAR})
        }
        if(!familyData) dispatch(userGenerateData())
    },[dispatch, file, familyData])

    return (
        <Template>
            <div className="home__header">
                {data && (data.isAdmin || data.isCoAdmin) &&
                <Button style={{width:'14rem', height:'3.5rem', position:'relative'}} variant='warning' onClick={() => setIsExport(!isExport)}>
                   {loading_p ? <div className="lds-dual-ring"></div> : 'تصدير الشجرة'}
                   <div className='home__export' style={{display:isExport ? 'flex': 'none'}}>
                       <Button variant='info' onClick={() => exportSVGHandler('png')}>PNG</Button>
                       <Button variant='info' onClick={() => exportSVGHandler('pdf')}>PDF</Button>
                   </div>
                </Button>}
                <Button variant='info' onClick={() => setIsProfile(!isProfile)}>
                    وضع العرض
                    <i className="fas fa-circle"
                    style={{color:isProfile ? '#197802': '#7b8a8b', textShadow: isProfile && '0px 12px 18px #18bc9c'}}>
                    </i>
                </Button>
                <Button variant='info' onClick={treeViewModeHandler}>
                    {treeViewMode === 'radial' ? 'شجرة قابلة للطي' : 'شجرة نصف دائرية'}
                    <i className={treeViewMode === 'radial' ? 'fas fa-project-diagram' : 'fas fa-circle-notch'}></i>
                </Button>
                <div className='home__treeSearch'>
                    <Button variant='info' onClick={() => setIsTreeSearchOpen(!isTreeSearchOpen)}>
                        بحث
                        <i className="fas fa-search"></i>
                    </Button>
                </div>
                <Button variant='info' onClick={() => setIsPoint(!isPoint)}>
                    وضع الإشارة
                    <i className="fas fa-hand-point-up"
                    style={{color:isPoint? '#197802': '#7b8a8b', textShadow: isPoint && '0px 12px 18px #18bc9c'}}>
                    </i>
                </Button>
                {isTreeSearchOpen && <div className='home__treeSearchPanel'>
                    <input
                        type='search'
                        value={treeSearchText}
                        placeholder='ابحث عن عضو في الشجرة'
                        autoFocus
                        onChange={({target:{value}}) => setTreeSearchText(value)}
                    />
                    <div className='home__treeSearchResults'>
                        {treeSearchText.trim().length === 0
                            ? <p>اكتب اسم العضو للانتقال إليه داخل الشجرة</p>
                            : treeSearchResults.length > 0
                                ? treeSearchResults.map(member => (
                                    <button
                                        key={member._id}
                                        onClick={() => {
                                            setSelectedTreeMember(member)
                                            setIsTreeSearchOpen(false)
                                        }}
                                    >
                                        <span>{member.displayName}</span>
                                        <i className='fas fa-location-arrow'></i>
                                    </button>
                                ))
                                : <p>لا توجد نتائج مطابقة</p>}
                    </div>
                </div>}
            </div>
            <div className="home__main">
               {error_f && <Alert variant='danger'>{error_f}</Alert>}
               {loading_f ? <Loader/>
               :familyData && familyData.length > 1
                     ? treeViewMode === 'radial'
                        ? <Tree
                            familyData={familyData}
                            isProfile={isProfile}
                            isPoint={isPoint}
                            selectedMemberId={selectedTreeMember && selectedTreeMember._id}
                          />
                        : <CollapseTree
                            familyData={familyData}
                            selectedMemberId={selectedTreeMember && selectedTreeMember._id}
                          />
                     : <div className="home__fallback">
                           ليس هناك بيانات لعرض شجرة العائلة
                           <span>من فضلك أضف الأعضاء من لوحة الإدارة</span>
                       </div>}
            </div>
        </Template>
    )
}

export default Home
